"use client";

import {
  Alert,
  AlertTitle,
  Button,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { heightNavigatonPx } from "@/lib/consts";

import { AbfindungStickySummary } from "./AbfindungStickySummary";
import { RVORechnerQuestionCard } from "./RVORechnerQuestionCard";
import { useAbfindungWizardState } from "./useAbfindungWizardState";

export enum SecurityType {
  SecuredFully = "SecuredFully",
  SecuredPartially = "SecuredPartially",
  Unsecured = "Unsecured",
}

export const SLCalcAbfindung = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"), {
    noSsr: true,
  });

  const {
    abfindung,
    isCalculatorStarted,
    startCalculator,
    counter,
    inputs,
    isMoreThan10,
    isMonthlyIncomeConfirmed,
    isCalculationStarted,
    monthlyIncome,
    beschäftigungsdauerInJahren,
    untergrenze,
    obergrenze,
  } = useAbfindungWizardState();

  return (
    <Stack
      sx={{
        mt: 4,
        mb: 8,
        gap: 2,
      }}
    >
      {!isCalculatorStarted ? (
        <Stack
          sx={{
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button variant="contained" size="large" onClick={startCalculator}>
            Abfindungsrechner starten
          </Button>
        </Stack>
      ) : (
        <Stack gap={2}>
          <Stack
            direction={isSmallScreen ? "column" : "row"}
            sx={{
              gap: 2,
            }}
          >
            <Stack
              sx={{
                gap: 2,
                pb: isSmallScreen ? 0 : "50vh",
                pt: 1,
              }}
            >
              {inputs.map((input, index) => {
                if (index <= counter) {
                  return (
                    <RVORechnerQuestionCard
                      key={index}
                      input={input}
                      isActive={index === counter && index !== 0}
                    />
                  );
                }
                return null;
              })}
            </Stack>

            <Stack
              sx={{
                maxWidth: isSmallScreen ? "100%" : "50%",
                width: "100%",
                position: "relative",
              }}
            >
              <Stack
                sx={{
                  gap: 2,
                  alignItems: "center",
                  pt: 1,
                  position: "sticky",
                  top: heightNavigatonPx,
                  width: "100%",
                }}
              >
                <AbfindungStickySummary
                  theme={theme}
                  counter={counter}
                  isMoreThan10={isMoreThan10}
                  isMonthlyIncomeConfirmed={isMonthlyIncomeConfirmed}
                  isCalculationStarted={isCalculationStarted}
                  monthlyIncome={monthlyIncome}
                  beschäftigungsdauerInJahren={beschäftigungsdauerInJahren}
                  untergrenze={untergrenze}
                  obergrenze={obergrenze}
                  abfindung={abfindung}
                />
              </Stack>
            </Stack>
          </Stack>
          <Alert severity="info">
            <AlertTitle>{abfindung.disclaimer.title}</AlertTitle>
            <Typography>{abfindung.disclaimer.body}</Typography>
          </Alert>
        </Stack>
      )}
    </Stack>
  );
};
